<template>
  <div class="user">
    <div class="user__tabs">
      <router-link to="/me" exact class="user__tab">
        {{ $t("user.tab.profile_card") }}
      </router-link>
      <router-link to="/me/user-cards" class="user__tab">
        {{ $t("user.tab.user_card") }}
      </router-link>
    </div>
    <div class="user__tab-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserPage",
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables";
@import "~@/assets/scss/mixins";
.user {
  width: 100%;
  margin-top: -50px;

  &__tabs {
    display: flex;
    align-items: center;
  }

  &__tab {
    height: 50px;
    font-size: 1.1666666667rem;
    line-height: 1.25rem;
    padding-left: 34px;
    padding-right: 51px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-bottom: unset;
    color: #2c2c30;
    border-radius: 16px 90px 0 0;
    text-decoration: none;

    &-content {
      padding: 25px 30px 40px;
      border: 1px solid #f0f3fa;
      border-radius: 0 0 16px 16px;
    }

    &.router-link-exact-active {
      border-color: #f0f3fa;
      color: $action;
    }
  }
}
</style>
